interface CostSummaryCardProps {
  product: string;
  timePeriod: string;
  countryRegion: string;
  units: string;
  totalCost: string;
}

const CostSummaryCard = ({
  product,
  timePeriod,
  countryRegion,
  units,
  totalCost,
}: CostSummaryCardProps) => {
  return (
    <div className="product-cost-table">
      {/* Header */}
      <div className="product-cost-table__header">
        <div className="product-cost-table__header-cell">Product</div>
        <div className="product-cost-table__header-cell">Time Period</div>
        <div className="product-cost-table__header-cell">County/Region</div>
        <div className="product-cost-table__header-cell">Units</div>
        <div className="product-cost-table__header-cell product-cost-table__header-cell--cost">
          Total Cost
        </div>
      </div>

      {/* Value Row */}
      <div className="product-cost-table__row">
        <div className="product-cost-table__cell">{product}</div>
        <div className="product-cost-table__cell">{timePeriod}</div>
        <div className="product-cost-table__cell">{countryRegion}</div>
        <div className="product-cost-table__cell">{units}</div>
        <div className="product-cost-table__cell product-cost-table__cell--cost">
          {totalCost}
        </div>
      </div>
    </div>
  );
};

export default CostSummaryCard;